export enum LoginType {
  GUARDIAN = 'guardian',
  STUDENT = 'student',
  EMPLOYEE = 'employee',
  TEACHER = 'teacher',
  SPONSOR = 'sponsor',
  SEO = 'seo',
}